/*!
  =========================================================
  * Essar Events Dashboard - Custom Footer
  =========================================================
*/

import { Layout, Row, Col } from "antd";

function Footer() {
  const { Footer: AntFooter } = Layout;
  const currentYear = new Date().getFullYear();

  return (
    <AntFooter style={{ background: "#fafafa" }}>
      <Row className="just">
        <Col xs={24} md={12} lg={12}>
          <div className="copyright">
            © {currentYear} Essar Systems. All rights reserved.
          </div>
        </Col>

        <Col xs={24} md={12} lg={12}>
          <div className="footer-menu">
            <ul>
              <li className="nav-item">
                <a href="#" className="nav-link text-muted">
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a href="#" className="nav-link text-muted">
                  Contact
                </a>
              </li>
              <li className="nav-item">
                <a href="#" className="nav-link pe-0 text-muted">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
